import React from 'react';

import {
  PayGreenBimpli as PayGreenBimplLogo,
  PayGreenEdenRed as PayGreenEdenRedLogo,
  PayGreenPassRestaurant as PayGreenPassRestaurantLogo,
  PayGreenRestoflash as PayGreenRestoflashLogo,
  PayGreenSwile as PayGreenSwileLogo,
  PayGreenUpDejeuner as PayGreenUpDejeunerLogo,
  PayGreenUpMonizze as PayGreenUpMonizzeLogo,
} from '../../../../../components/icons/logos';
import { SavedRestaurantVoucher } from '../../../../../core/state/payment/payment.types';

const checkVoucherCoversFullAmount = (
  availableBalance: number,
  orderTotalToPay: number,
): boolean => getBalanceOutstanding(availableBalance, orderTotalToPay) === 0;

const getBalanceOutstanding = (
  availableBalance: number,
  orderTotalToPay: number,
): number => {
  const balanceOutstanding = orderTotalToPay - availableBalance;
  const isSupplementaryPaymentRequired = balanceOutstanding > 0;

  if (isSupplementaryPaymentRequired) {
    return balanceOutstanding;
  }

  return 0;
};

const getFirstAvailableVoucher = (
  orderTotalToPay: number,
  voucherOptions: SavedRestaurantVoucher[],
): SavedRestaurantVoucher | undefined =>
  voucherOptions.find((opt) =>
    restaurantVoucherUtils.checkVoucherCoversFullAmount(
      opt.AvailableBalance,
      orderTotalToPay,
    ),
  );

const getSelectedVoucher = (
  selectedVoucherId: number,
  voucherOptions: SavedRestaurantVoucher[],
): SavedRestaurantVoucher =>
  voucherOptions.find((opt) => opt.PaymentAccountId === selectedVoucherId);

const getVoucherCharge = (
  availableBalance: number,
  orderTotalToPay: number,
): number => {
  const balanceOutstanding = orderTotalToPay - availableBalance;
  const isSupplementaryPaymentRequired = balanceOutstanding > 0;

  if (isSupplementaryPaymentRequired) {
    return -availableBalance;
  }

  return -orderTotalToPay;
};

const getVoucherLogo = (
  description: string,
  isDisabled: boolean,
  variant: 'default' | 'small',
  voucherBrand: string,
  voucherScheme: string,
): JSX.Element | string => {
  const voucher = voucherScheme.concat('-', voucherBrand).toUpperCase();

  switch (voucher) {
    case 'TRD-UPCHEQUEDEJEUNER': {
      return (
        <PayGreenUpDejeunerLogo isDisabled={isDisabled} variant={variant} />
      );
    }
    case 'TRD-BIMPLI': {
      return <PayGreenBimplLogo isDisabled={isDisabled} variant={variant} />;
    }
    case 'TRD-PASSRESTAURANT': {
      return (
        <PayGreenPassRestaurantLogo isDisabled={isDisabled} variant={variant} />
      );
    }
    case 'LUNCHR-SWILE': {
      return <PayGreenSwileLogo isDisabled={isDisabled} variant={variant} />;
    }
    case 'ETR-EDENRED': {
      return <PayGreenEdenRedLogo isDisabled={isDisabled} variant={variant} />;
    }
    case 'MONIZZEMEAL-MONIZZE': {
      return (
        <PayGreenUpMonizzeLogo isDisabled={isDisabled} variant={variant} />
      );
    }
    case 'RESTOFLASH-RESTOFLASH': {
      return (
        <PayGreenRestoflashLogo isDisabled={isDisabled} variant={variant} />
      );
    }
    default:
      return description;
  }
};

export const restaurantVoucherUtils = {
  checkVoucherCoversFullAmount,
  getBalanceOutstanding,
  getSelectedVoucher,
  getFirstAvailableVoucher,
  getVoucherCharge,
  getVoucherLogo,
};
